import { render } from "./ViewResultCard.vue?vue&type=template&id=4a7e85f1&ts=true"
import script from "./ViewResultCard.vue?vue&type=script&lang=ts"
export * from "./ViewResultCard.vue?vue&type=script&lang=ts"

import "./ViewResultCard.vue?vue&type=style&index=0&id=4a7e85f1&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__